import styled from "styled-components";

export const TsrWithDropdownOptionSelectorBox = styled.select`
    margin-bottom: 5rem;
    margin-top: 0.5rem;
    padding: 10px;
        
    font-size: 1.5rem;
        
    color: ${({theme}) => theme.colors.bodyText};
    background-color: ${props => props.theme.colors.headerBackground};
    
    border-radius: ${({theme}) => theme.layout.border.radius};
    border-color: ${({theme}) => theme.colors.modalDialogBorder};            
    border-width: 2px;
    border-style: solid;

    overflow: hidden;
    
    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.landscape}`} {
        margin-bottom: 2rem;
    }
`;